var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ucy9dis5va",
    d: "M0 0h40v40H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.557 .4)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "twwbwj20wb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ucy9dis5va"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.571 23.59c.79 0 1.429.671 1.429 1.5v4.502c0 1.105-.858 1.998-1.905 1.998h-16.19c-1.051 0-1.905-.899-1.905-1.998V25.09c0-.829.64-1.5 1.429-1.5s1.428.671 1.428 1.5v2.998c0 .283.213.502.475.502h13.336a.49.49 0 0 0 .475-.502V25.09c0-.829.64-1.5 1.428-1.5zM20 8a1.49 1.49 0 0 1 1.496 1.482v9.12c0 .546.316.678.707.288l1.717-2.5c1.41-1.4 3.525.7 2.115 2.102l-4.962 5.063a1.464 1.464 0 0 1-2.095.007l-5.013-5.07c-1.41-1.401.705-3.503 2.115-2.102l1.717 2.5c.39.39.707.26.707-.288v-9.12C18.504 8.668 19.174 8 20 8z",
    fill: "#FFF",
    mask: "url(#twwbwj20wb)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnDownload);
export default __webpack_public_path__ + "static/media/icn-download.55136358fe09d97906c8575042064fe4.svg";
export { ForwardRef as ReactComponent };